import {Node, mergeAttributes} from "@tiptap/core";
import {ReactNodeViewRenderer} from "@tiptap/react";
import {FormFieldNodeView} from "./form-field-node-view";

export const FormField = Node.create({
  name: "formField",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      value: {
        default: "",
        parseHTML: (element) => element.textContent,
      },
      placeholder: {
        default: "Type here…",
      },
    };
  },

  parseHTML() {
    return [{tag: 'span[data-type="form-field"]'}];
  },

  renderHTML({HTMLAttributes}) {
    return [
      "span",
      mergeAttributes({
        "data-type": "form-field",
        "data-placeholder": HTMLAttributes.placeholder,
      }),
      HTMLAttributes.value,
    ];
  },

  addCommands() {
    return {
      insertFormField:
        (attrs = {}) =>
        ({commands}) => {
          return commands.insertContent({type: this.name, attrs});
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(FormFieldNodeView);
  },
});
